import { render, staticRenderFns } from "./LiteraryClub.vue?vue&type=template&id=76369fcb&"
import script from "./LiteraryClub.vue?vue&type=script&lang=ts&"
export * from "./LiteraryClub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports